import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AppConfigProvider } from "./context/AppConfigContext";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppConfigProvider>
      <App />
    </AppConfigProvider>
  </React.StrictMode>,
);
